import { parsePublishedArtifactRawData } from '@/pages/home/utils/publishedArtifact';

import type { ArtifactItem } from '../../artifact-center/shared';
import type { ModelPlazaArtifactItem } from './types';

/** 将 nologin 制品项解析为模型仓库列表可用的 ArtifactItem（展示字段取自 rawData） */
export function publishedArtifactToArtifactItem(item: ModelPlazaArtifactItem): ArtifactItem {
  const raw = parsePublishedArtifactRawData(item.rawData);
  // 与无 SKU 下单 modelId 对齐：优先 rawData.id
  const id = (typeof raw.id === 'string' && raw.id ? raw.id : '') || item.artifactId || '';

  return {
    ...(raw as ArtifactItem),
    id,
    name: raw.name ?? item.name ?? '',
    description: raw.description ?? item.description,
    opsTag: Array.isArray(raw.opsTag) ? raw.opsTag : (item.opsTags ?? []),
    inferenceFrameworkTags: Array.isArray(raw.inferenceFrameworkTags) ? raw.inferenceFrameworkTags : (item.inferenceFrameworkTags ?? []),
  };
}

/** 批量转换列表响应 */
export function mapModelPlazaListItems(items: ModelPlazaArtifactItem[] = []): ArtifactItem[] {
  return items.map(publishedArtifactToArtifactItem).filter((item) => item.id);
}
